import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Button from "../../../components/buttons/buttons";
import Input from "../../../components/inputs/inputs";
// docsImages
import { XIcon } from "@heroicons/react/outline";
import { Beat } from "../../../plugins/spinners.plugin";
import {
  editHumanVerificationAction,
  showMyHumanVerification,
} from "../../../redux/humanVerification/humanVerificationActions";

export default function EditKYCVerification() {
  const dispatch = useDispatch();
  const hiddenDocsInput = useRef(null);
  const hiddenProofInput = useRef(null);

  // const [profileData, setprofileData] = useState({});
  const [data, setData] = useState({});
  const [docsImages, setDocsImages] = useState([]);
  const [livePhotos, setLivePhotos] = useState([]);
  const [photosUrl, setPhotosUrl] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  const { updating, userVerification } = useSelector(
    (state) => state.humanVerification
  );
  console.log("userVerification", userVerification);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(showMyHumanVerification());
  }, [dispatch]);

  //handling removing and adding images to existing images
  useEffect(() => {
    if (userVerification?.documents?.length > 0) {
      setData({
        ...data,
        user_id: userVerification?.user_id,
        document_type: userVerification?.document_type,
        document_number: userVerification?.document_number,
        url_docs: userVerification?.documents,
        url_photos: userVerification?.pictures,
      });
    }
    // eslint-disable-next-line
  }, [userVerification?.documents, userVerification?.pictures]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setData({ ...data, [name]: value });
  };

  function onImageChange(e) {
    const files = Array.from(e.target.files);
    const maxSize = 2 * 1024 * 1024; // 2MB
    
    // Validate file types (only documents)
    const validDocTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain'];
    const invalidTypeFiles = files.filter(file => !validDocTypes.includes(file.type));
    
    if (invalidTypeFiles.length > 0) {
      toast.error("Only document files (PDF, DOC, DOCX, TXT) are allowed for identity documents", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 4000,
      });
      e.target.value = ""; // Reset input
      return;
    }
    
    // Validate each file size
    const invalidFiles = files.filter(file => file.size > maxSize);
    
    if (invalidFiles.length > 0) {
      toast.error("Each document file must be less than 2MB", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 4000,
      });
      e.target.value = ""; // Reset input
      return;
    }
    
    setDocsImages([...files]);
  }

  const handleDocsClick = (event) => {
    event.preventDefault();
    hiddenDocsInput.current.click();
  };

  const handleProofClick = (event) => {
    event.preventDefault();
    hiddenProofInput.current.click();
  };

  const removeFile = (index) => {
    let newArr = docsImages;
    newArr.splice(index, 1);
    setDocsImages([...newArr]);
  };

  const removeUrlDocs = (index) => {
    let newArr = [...data?.url_docs];
    newArr.splice(index, 1);
    setData({ ...data, url_docs: newArr });
  };

  const uploadProofOfLife = (e) => {
    const files = Array.from(e.target.files);
    const maxSize = 2 * 1024 * 1024; // 2MB
    
    // Validate file types (only images)
    const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    const invalidTypeFiles = files.filter(file => !validImageTypes.includes(file.type));
    
    if (invalidTypeFiles.length > 0) {
      toast.error("Only image files (JPEG, PNG, GIF, WebP) are allowed for proof of life", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 4000,
      });
      e.target.value = ""; // Reset input
      return;
    }
    
    // Validate each file size
    const invalidFiles = files.filter(file => file.size > maxSize);
    
    if (invalidFiles.length > 0) {
      toast.error("Proof of life image must be less than 2MB", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 4000,
      });
      e.target.value = ""; // Reset input
      return;
    }
    
    setLivePhotos([...files]);
  };

  const removeUrlPhotos = (index) => {
    let newArr = [...data?.url_photos];
    newArr.splice(index, 1);
    setData({ ...data, url_photos: newArr });
  };

  useEffect(() => {
    if (livePhotos.length < 1) return;
    if (livePhotos.length > 0) {
      const newImageUrls = [];
      livePhotos?.forEach((image) => {
        newImageUrls.push(URL.createObjectURL(image));
      });
      setPhotosUrl(newImageUrls);
    }
    // eslint-disable-next-line
  }, [livePhotos]);

  const handleSubmit = async () => {
    setSubmitted(true);
    
    // Validate array limits
    const totalDocs = (data.url_docs?.length || 0) + (docsImages?.length || 0);
    const totalPhotos = (data.url_photos?.length || 0) + (livePhotos?.length || 0);
    
    if (totalDocs > 3) {
      toast.error("You can only have up to 3 document images in total", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 4000,
      });
      return;
    }
    
    if (totalPhotos > 3) {
      toast.error("You can only have up to 3 proof of life images in total", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 4000,
      });
      return;
    }
    
    try {
      const payload = {
        user_id: data.user_id,
        document_type: data.document_type,
        document_number: data.document_number,
        url_docs: data.url_docs || [],
        url_photos: data.url_photos || [],
        docs: docsImages || [],
        photos: livePhotos || [],
      };
      
      dispatch(editHumanVerificationAction(payload));
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <div>
      <form className="sm:px-10">
        <div className="sm:grid sm:grid-cols-1 gap-1">
          {/* grid column one begins */}
          <div className="relative">
            <div className="absolute right-0 text-sm">
              {userVerification?.status === "approved" && (
                <span className="px-2 py-1 rounded-md text-[#00D220] bg-[#D1FED8]">
                  Approved
                </span>
              )}
              {userVerification?.status === "pending" && (
                <span className="px-2 py-1 rounded-md text-[#FFA927] bg-[#FFE2B6]">
                  Pending
                </span>
              )}
              {userVerification?.status === "rejected" && (
                <span className="px-2 py-1 rounded-md text-primary bg-[#ce260026]">
                  Rejected
                </span>
              )}
            </div>
            <Input.Select
              title={"Select Identity Card"}
              name="document_type"
              id="document_type"
              className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
              htmlFor="document_type"
              disabled={
                userVerification?.status === "approved" ||
                userVerification?.status === "pending"
              }
              defaultValue={userVerification?.document_type}
              onChange={handleChange}
            >
              <option>Select card type</option>
              <option>Drivers License</option>
              <option>International Passport</option>
              <option>NIN</option>
            </Input.Select>
            {submitted && !data?.document_type && (
              <div className="text-primary text-xs ">
                Document Type is required
              </div>
            )}
          </div>

          <div>
            <label
              htmlFor="document_number"
              className="block text-sm font-medium"
            >
              Enter Identity Card number
            </label>
            <div className="mt-2">
              <input
                type="number"
                name="document_number"
                id="document_number"
                className="mt-2 block pl-3 pr-10 w-full text-base bg-[#FFFFFF] focus:ring-2 focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm h-[40px] px-4 py-2 mb-4 border border-gray-300 "
                placeholder="Enter Identity Card number"
                defaultValue={userVerification?.document_number}
                disabled={
                  userVerification?.status === "approved" ||
                  userVerification?.status === "pending"
                }
                onChange={(e) => handleChange(e)}
              />
            </div>
            {submitted && !data?.document_number && (
              <div className="text-primary text-xs ">
                ID Card number is required
              </div>
            )}
          </div>

          <div>
            <label htmlFor="first_name" className="block text-sm font-medium">
              Upload Identity Card (Accepts .pdf, .doc, .docx, .txt formats)
            </label>
            <div className="mt-2">
              <button
                className="w-full border border-[#E4E4F3] bg-[#FAFAFA] p-3 text-center text-[#9CA3AF]"
                onClick={handleDocsClick}
                disabled={
                  userVerification?.status === "approved" ||
                  userVerification?.status === "pending"
                }
              >
                + Upload Document
              </button>
              <input
                type="file"
                className="hidden"
                accept=".pdf,.doc,.docx,.txt,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain"
                onChange={onImageChange}
                ref={hiddenDocsInput}
              />
              {submitted &&
                (docsImages?.length < 1 && data?.url_docs?.length < 1) && (
                  <div className="text-primary text-xs ">
                    Identity Card document is required
                  </div>
                )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 mb-4">
              {data?.url_docs?.length > 0 &&
                data?.url_docs?.map((doc, index) => (
                  <div className="border border-gray-300 rounded-md p-4 flex items-center justify-between" key={index}>
                    <div className="flex items-center gap-3">
                      <svg className="w-8 h-8 text-primary" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
                      </svg>
                      <span className="text-sm truncate">Document {index + 1}</span>
                    </div>
                    <button
                      type="button"
                      className="h-8 w-8 bg-[#FAE9E6] rounded-full flex items-center justify-center"
                      onClick={() => removeUrlDocs(index)}
                    >
                      <XIcon className="h-5 w-5 text-primary" />
                    </button>
                  </div>
                ))}

              {docsImages?.length > 0 &&
                docsImages?.map((file, index) => (
                  <div className="border border-gray-300 rounded-md p-4 flex items-center justify-between" key={index}>
                    <div className="flex items-center gap-3">
                      <svg className="w-8 h-8 text-primary" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
                      </svg>
                      <span className="text-sm truncate max-w-[200px]">{file.name}</span>
                    </div>
                    <button
                      type="button"
                      className="h-8 w-8 bg-[#FAE9E6] rounded-full flex items-center justify-center"
                      onClick={() => removeFile(index)}
                    >
                      <XIcon className="h-5 w-5 text-primary" />
                    </button>
                  </div>
                ))}
            </div>
          </div>
          {/* grid ends */}

          <div>
            <label htmlFor="first_name" className="block text-sm font-medium">
              Upload Proof Of Life
            </label>
            <div className="mt-2">
              <button
                className="w-full border border-[#E4E4F3] bg-[#FAFAFA] p-3 text-center text-[#9CA3AF]"
                onClick={handleProofClick}
                disabled={
                  userVerification?.status === "approved" ||
                  userVerification?.status === "pending"
                }
              >
                + Upload Image
              </button>
              <input
                type="file"
                className="hidden"
                accept="image/*"
                onChange={uploadProofOfLife}
                ref={hiddenProofInput}
              />
              {submitted &&
                (livePhotos?.length < 1 || data?.url_photos?.length < 1) && (
                  <div className="text-primary text-xs ">
                    Proof of life is required
                  </div>
                )}
            </div>
            <div className="mt-4 ">
              {photosUrl?.length > 0 ? (
                <div className="grid grid-cols-1 gap-8">
                  {photosUrl.map((url, index) => (
                    <figure className="w-full h-[250px] relative" key={index}>
                      <img
                        src={url}
                        className="object-cover w-full h-[250px]"
                        alt="banner"
                      />
                    </figure>
                  ))}
                </div>
              ) : (
                data?.url_photos?.length > 0 && (
                  <div className="grid grid-cols-1 gap-8">
                    {data?.url_photos.map((banner, index) => (
                      <figure className="w-full h-[250px] relative" key={index}>
                        <img
                          src={banner}
                          className="object-cover w-full h-[250px]"
                          alt="banner"
                        />
                        <button
                          type="button"
                          className="h-8 w-8 bg-[#FAE9E6] rounded-full absolute right-2 top-2"
                          onClick={() => removeUrlPhotos(index)}
                        >
                          <XIcon className="h-5 w-5 text-primary mx-auto" />
                        </button>
                      </figure>
                    ))}
                  </div>
                )
              )}
            </div>
          </div>
        </div>

        <div className="my-10 flex flex-col items-center justify-center">
          {userVerification?.status === "approved" ||
          userVerification?.status === "pending" ? (
            ""
          ) : (
            <Button.Primary
              type="button"
              disabled={updating}
              title={updating ? <Beat color="#ffffff" /> : "Update KYC"}
              className={"sm:block rounded-md mb-6 sm:mb-0 w-full sm:w-[333px]"}
              onClick={(e) => handleSubmit(e)}
            />
          )}
        </div>
      </form>
    </div>
  );
}
